module.exports = __webpack_public_path__ + "img/mayBanner_1920.733976cf.png";